// 5 minutes — long enough to avoid hammering the API, short enough to catch daily promo changes
export const SPECIALS_POLL_INTERVAL_MS = 300_000;
export const SPECIALS_POLL_DEGRADATION_MULTIPLIER = 10;
